import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import { Text } from '../../../model/text';
import { text } from '../../../functions/localization';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { convertToHtml } from '../../../functions/convertToHtml';
import {Subscription} from 'rxjs';
import {LocalizationService} from '../../../services/localization.service';

@Component({
  selector: 'app-texts',
  templateUrl: './texts.component.html',
  standalone: true,
  styleUrls: ['./texts.component.scss']
})
export class TextsComponent implements OnInit, OnDestroy, OnChanges {
  constructor(private localizationService: LocalizationService,
              private sanitizer: DomSanitizer) {}

  @Input() texts: Text[] = [];
  safeHtml: SafeHtml = '';
  private langSub!: Subscription;



  ngOnInit() {
    this.langSub = this.localizationService.language$.subscribe(() => {
      this.updateSafeHtml();
    });
  }

  ngOnDestroy() {
    if (this.langSub) {
      this.langSub.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['texts']) {
      this.updateSafeHtml();
    }
  }

  updateSafeHtml() {
    let t = '';
    for (const txt of this.texts) {
      const content = text(txt.text ?? []);
      t += `<span class="${this.getClass(txt)}">${content}</span>`;
      if (txt.transfer) t += '<br>';
    }
    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(convertToHtml(t));
  }


  get getText(): SafeHtml {
    return this.safeHtml;
  }

  getClass(text: Text): string {
    let c = '';
    if (text.fontFamily) c += 't-font-family-' + text.fontFamily + ' ';
    else c += 't-font-family-manrope ';
    if (text.fontWeight) c += 't-font-weight-' + text.fontWeight + ' ';
    if (text.textTransform) c += 't-text-transform-' + text.textTransform + ' ';
    if (text.color) c += 't-color-' + text.color + ' ';
    if (text.fontStyle) c += 't-font-style-' + text.fontStyle + ' ';
    if (text.noWarp) c += 't-no-warp';
    return c;
  }

  protected readonly text = text;
}
